import {TAX_INVOICES_REQUEST, TAX_INVOICES_RESPONSE} from '../actions/taxInvoices.actions';

export default function taxInvoices(state = [], action) {
  switch (action.type) {
    case TAX_INVOICES_REQUEST: {
      return [];
    }
    case TAX_INVOICES_RESPONSE: {
      let nextState = action.taxInvoices;
      return nextState;
    }
  }
  return state;
}
